(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
      
document.addEventListener('DOMContentLoaded', function() {
    var brandHistoryElement = document.querySelector('#brand-history-tag1');
    var productDescriptionElement = document.querySelector('#product-description-tag1');

    function isVisible(element) {
        // Clona l'elemento per manipolazione
        var clone = element.cloneNode(true); 
        // Trova e rimuove il link del venditore nel clone
        var vendorLink = clone.querySelector('#vendorbrand'); 
        if (vendorLink) {
            vendorLink.remove(); 
        }
        // Verifica se rimane del testo visibile
        return clone.textContent.trim().length > 0; 
    }

    // Nasconde l'elemento <details> del brand e il bordo se non ci sono contenuti visibili
    if (brandHistoryElement && !isVisible(brandHistoryElement)) {
        var detailsElement = brandHistoryElement.closest('details');
        if (detailsElement) {
            detailsElement.style.display = 'none';
            // Trova e nasconde anche il contenitore .accordion
            var accordionElement = detailsElement.previousElementSibling;
            if (accordionElement && accordionElement.classList.contains('accordion')) {
                accordionElement.style.display = 'none';
            }
        }
    }

    // Nasconde l'elemento <details> della descrizione del prodotto se non ci sono contenuti visibili
    if (productDescriptionElement && !productDescriptionElement.textContent.trim()) {
        var productDetailsElement = productDescriptionElement.closest('details');
        if (productDetailsElement) {
            productDetailsElement.style.display = 'none';
            // Trova e nasconde anche il contenitore .accordion
            var accordionElement = productDetailsElement.previousElementSibling;
            if (accordionElement && accordionElement.classList.contains('accordion')) {
                accordionElement.style.display = 'none';
            }
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-grid"]) return;
  try {
    
$(document).ajaxComplete(function(event, xhr, settings) {
	if(settings) {
    	if(settings.url.indexOf("cart.js")!=-1) {    
             var cartData = JSON.parse(xhr.responseText);
             var country = cartData.attributes.country;
             if(all_countryEnabled || enabledCountries.includes(country)){ 
              	var geoElements = document.getElementsByClassName("geoImg");
				var i;
                for (i = 0; i < geoElements.length; i++) {
                  geoElements[i].style.display = "block";
                }	
			 }
		}
	}
})

  } catch(e) { console.error(e); }
})();
})();
